// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"8ef557f1","197":"b8a7b6ce","419":"3563021e","439":"5f4dc080","458":"130ee570","774":"51b8e019","787":"c22bc4f0","820":"6c2ea0b0","858":"7a30e86f","910":"16b951e1"}[chunkId] + ".chunk.js";
};